export const normalizePointId = (id: string | null | undefined): string =>
  String(id ?? "")
    .replace(/-/g, "")
    .toLowerCase();

export const buildGroupByPointIdMap = <T>(
  list: T[],
  getId: (item: T) => string | null | undefined
): Map<string, T[]> => {
  const map = new Map<string, T[]>();

  list.forEach((item) => {
    const key = normalizePointId(getId(item));

    if (!key) {
      return;
    }

    const existing = map.get(key) || [];
    existing.push(item);
    map.set(key, existing);
  });

  return map;
};
